var _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1050,
    height: 700,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -180,
    y: -150,
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("div", {
    id: "wordcloud",
    className: "Word-cloud",
    style: {
      placeContent: "normal center",
      placeItems: "center normal",
      placeSelf: "auto",
      alignmentBaseline: "none",
      animation: "0s ease 0s 1 normal none running none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      background: "none 0% 0% / auto repeat scroll padding-box border-box rgb(255, 255, 255)",
      backgroundBlendMode: "normal",
      baselineShift: 0,
      blockSize: "746.188px",
      borderBlock: "0px none rgb(0, 0, 0)",
      border: "0px none rgb(0, 0, 0)",
      borderRadius: 0,
      borderCollapse: "separate",
      borderInline: "0px none rgb(0, 0, 0)",
      inset: "auto",
      boxShadow: "none",
      boxSizing: "content-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(0, 0, 0)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(0, 0, 0)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columns: "auto auto",
      gap: "normal",
      columnRule: "0px none rgb(0, 0, 0)",
      columnSpan: "none",
      content: "normal",
      cursor: "auto",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "flex",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flex: "0 1 auto",
      flexFlow: "row nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      font: "400 28px Rubik, sans-serif",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridArea: "auto / 1 / auto / 4",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "746.188px",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "1422.75px",
      insetBlock: "auto",
      insetInline: "auto",
      isolation: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      listStyle: "outside none disc",
      marginBlock: "8px 0px",
      margin: "8px 0px 0px",
      marginInline: 0,
      marker: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: "auto",
      minHeight: "auto",
      minInlineSize: "auto",
      minWidth: "auto",
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offset: "none 0px auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outline: "rgb(0, 0, 0) none 0px",
      outlineOffset: 0,
      overflowAnchor: "auto",
      overflowWrap: "normal",
      overflow: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlock: 0,
      padding: 0,
      paddingInline: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "711.375px 373.094px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlock: 0,
      scrollMarginInline: 0,
      scrollPaddingBlock: "auto",
      scrollPaddingInline: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(0, 0, 0)",
      textDecorationSkipInk: "auto",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "auto",
      textTransform: "none",
      textUnderlinePosition: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "711.375px 373.094px",
      transformStyle: "flat",
      transition: "all 0s ease 0s",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "1422.75px",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      borderSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLocale: "&quot",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMask: "none 0% 0% / auto repeat border-box border-box",
      WebkitMaskComposite: "source-over",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0.18)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasis: "none rgb(0, 0, 0)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextFillColor: "rgb(0, 0, 0)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStroke: "0px rgb(0, 0, 0)",
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    },
    xmlns: "http://www.w3.org/1999/xhtml"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      placeContent: "normal",
      placeItems: "normal",
      placeSelf: "auto",
      alignmentBaseline: "auto",
      animation: "0s ease 0s 1 normal none running none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      background: "none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0)",
      backgroundBlendMode: "normal",
      baselineShift: 0,
      blockSize: 746,
      borderBlock: "0px none rgb(0, 0, 0)",
      border: "0px none rgb(0, 0, 0)",
      borderRadius: 0,
      borderCollapse: "separate",
      borderInline: "0px none rgb(0, 0, 0)",
      inset: "auto",
      boxShadow: "none",
      boxSizing: "content-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(0, 0, 0)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(0, 0, 0)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columns: "auto auto",
      gap: "normal",
      columnRule: "0px none rgb(0, 0, 0)",
      columnSpan: "none",
      content: "normal",
      cursor: "auto",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "block",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flex: "0 1 auto",
      flexFlow: "row nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      font: "400 28px Rubik, sans-serif",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridArea: "auto / auto / auto / auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: 746,
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: 1423,
      insetBlock: "auto",
      insetInline: "auto",
      isolation: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      listStyle: "outside none disc",
      marginBlock: 0,
      margin: 0,
      marginInline: 0,
      marker: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: "auto",
      minHeight: "auto",
      minInlineSize: "auto",
      minWidth: "auto",
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offset: "none 0px auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outline: "rgb(0, 0, 0) none 0px",
      outlineOffset: 0,
      overflowAnchor: "auto",
      overflowWrap: "normal",
      overflow: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlock: 0,
      padding: 0,
      paddingInline: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "711.5px 373px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlock: 0,
      scrollMarginInline: 0,
      scrollPaddingBlock: "auto",
      scrollPaddingInline: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(0, 0, 0)",
      textDecorationSkipInk: "auto",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "auto",
      textTransform: "none",
      textUnderlinePosition: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "711.5px 373px",
      transformStyle: "flat",
      transition: "all 0s ease 0s",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: 1423,
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      borderSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLocale: "&quot",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMask: "none 0% 0% / auto repeat border-box border-box",
      WebkitMaskComposite: "source-over",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0.18)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasis: "none rgb(0, 0, 0)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextFillColor: "rgb(0, 0, 0)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStroke: "0px rgb(0, 0, 0)",
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }, /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      placeContent: "normal",
      placeItems: "normal",
      placeSelf: "auto",
      alignmentBaseline: "auto",
      animation: "0s ease 0s 1 normal none running none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "in background: none 0% 0% / visible",
      background: "none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0)",
      backgroundBlendMode: "normal",
      baselineShift: 0,
      blockSize: 746,
      borderBlock: "0px none rgb(0, 0, 0)",
      border: "0px none rgb(0, 0, 0)",
      borderRadius: 0,
      borderCollapse: "separate",
      borderInline: "0px none rgb(0, 0, 0)",
      inset: "auto",
      boxShadow: "none",
      boxSizing: "content-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(0, 0, 0)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(0, 0, 0)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columns: "auto auto",
      gap: "normal",
      columnRule: "0px none rgb(0, 0, 0)",
      columnSpan: "none",
      content: "normal",
      cursor: "auto",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "block",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flex: "0 1 auto",
      flexFlow: "row nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      font: "400 28px Rubik, sans-serif",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridArea: "auto / auto / auto / auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: 746,
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: 1423,
      insetBlock: "auto",
      insetInline: "auto",
      isolation: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      listStyle: "outside none disc",
      marginBlock: 0,
      margin: 0,
      marginInline: 0,
      marker: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offset: "none 0px auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outline: "rgb(0, 0, 0) none 0px",
      outlineOffset: 0,
      overflowAnchor: "auto",
      overflowWrap: "normal",
      overflow: "hidden",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlock: 0,
      padding: 0,
      paddingInline: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "711.5px 373px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlock: 0,
      scrollMarginInline: 0,
      scrollPaddingBlock: "auto",
      scrollPaddingInline: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(0, 0, 0)",
      textDecorationSkipInk: "auto",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "auto",
      textTransform: "none",
      textUnderlinePosition: "auto",
      touchAction: "auto",
      transform: "none",
      transformOrigin: "711.5px 373px",
      transformStyle: "flat",
      transition: "all 0s ease 0s",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: 1423,
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      borderSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLocale: "&quot",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMask: "none 0% 0% / auto repeat border-box border-box",
      WebkitMaskComposite: "source-over",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0.18)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasis: "none rgb(0, 0, 0)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextFillColor: "rgb(0, 0, 0)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStroke: "0px rgb(0, 0, 0)",
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    },
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(711.5, 373)",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      placeContent: "normal",
      placeItems: "normal",
      placeSelf: "auto",
      alignmentBaseline: "auto",
      animation: "0s ease 0s 1 normal none running none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      background: "none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0)",
      backgroundBlendMode: "normal",
      baselineShift: 0,
      blockSize: "auto",
      borderBlock: "0px none rgb(0, 0, 0)",
      border: "0px none rgb(0, 0, 0)",
      borderRadius: 0,
      borderCollapse: "separate",
      borderInline: "0px none rgb(0, 0, 0)",
      inset: "auto",
      boxShadow: "none",
      boxSizing: "content-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(0, 0, 0)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(0, 0, 0)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columns: "auto auto",
      gap: "normal",
      columnRule: "0px none rgb(0, 0, 0)",
      columnSpan: "none",
      content: "normal",
      cursor: "auto",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "inline",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(0, 0, 0)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flex: "0 1 auto",
      flexFlow: "row nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      font: "400 28px Rubik, sans-serif",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridArea: "auto / auto / auto / auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlock: "auto",
      insetInline: "auto",
      isolation: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      listStyle: "outside none disc",
      marginBlock: 0,
      margin: 0,
      marginInline: 0,
      marker: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offset: "none 0px auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outline: "rgb(0, 0, 0) none 0px",
      outlineOffset: 0,
      overflowAnchor: "auto",
      overflowWrap: "normal",
      overflow: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlock: 0,
      padding: 0,
      paddingInline: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlock: 0,
      scrollMarginInline: 0,
      scrollPaddingBlock: "auto",
      scrollPaddingInline: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "start",
      textDecoration: "none solid rgb(0, 0, 0)",
      textDecorationSkipInk: "auto",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "auto",
      textTransform: "none",
      textUnderlinePosition: "auto",
      touchAction: "auto",
      transform: "matrix(1, 0, 0, 1, 711.5, 373)",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transition: "all 0s ease 0s",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "normal",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      borderSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLocale: "&quot",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMask: "none 0% 0% / auto repeat border-box border-box",
      WebkitMaskComposite: "source-over",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0.18)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasis: "none rgb(0, 0, 0)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextFillColor: "rgb(0, 0, 0)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStroke: "0px rgb(0, 0, 0)",
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }, /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "rgb(147, 73, 169)",
    fontFamily: "Quicksand",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-111, 18)",
    fontSize: "65px",
    tabIndex: 0,
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      placeContent: "normal",
      placeItems: "normal",
      placeSelf: "auto",
      alignmentBaseline: "auto",
      animation: "0s ease 0s 1 normal none running none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      background: "none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0)",
      backgroundBlendMode: "normal",
      baselineShift: 0,
      blockSize: "auto",
      borderBlock: "0px none rgb(0, 0, 0)",
      border: "0px none rgb(0, 0, 0)",
      borderRadius: 0,
      borderCollapse: "separate",
      borderInline: "0px none rgb(0, 0, 0)",
      inset: "auto",
      boxShadow: "none",
      boxSizing: "content-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(0, 0, 0)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(0, 0, 0)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columns: "auto auto",
      gap: "normal",
      columnRule: "0px none rgb(0, 0, 0)",
      columnSpan: "none",
      content: "normal",
      cursor: "default",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "block",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(147, 73, 169)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flex: "0 1 auto",
      flexFlow: "row nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      font: "700 65px Quicksand",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridArea: "auto / auto / auto / auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlock: "auto",
      insetInline: "auto",
      isolation: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      listStyle: "outside none disc",
      marginBlock: 0,
      margin: 0,
      marginInline: 0,
      marker: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offset: "none 0px auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outline: "rgb(0, 0, 0) none 0px",
      outlineOffset: 0,
      overflowAnchor: "auto",
      overflowWrap: "normal",
      overflow: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlock: 0,
      padding: 0,
      paddingInline: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlock: 0,
      scrollMarginInline: 0,
      scrollPaddingBlock: "auto",
      scrollPaddingInline: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "middle",
      textDecoration: "none solid rgb(0, 0, 0)",
      textDecorationSkipInk: "auto",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "auto",
      textTransform: "none",
      textUnderlinePosition: "auto",
      touchAction: "auto",
      transform: "matrix(1, 0, 0, 1, -111, 18)",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transition: "all 0s ease 0s",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "nowrap",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      borderSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLocale: "&quot",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMask: "none 0% 0% / auto repeat border-box border-box",
      WebkitMaskComposite: "source-over",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0.18)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasis: "none rgb(0, 0, 0)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextFillColor: "rgb(0, 0, 0)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStroke: "0px rgb(0, 0, 0)",
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }, "ihre friseurmeisterin"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "rgb(102, 76, 109)",
    fontFamily: "Quicksand",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-155, 53)",
    fontSize: "28px",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      placeContent: "normal",
      placeItems: "normal",
      placeSelf: "auto",
      alignmentBaseline: "auto",
      animation: "0s ease 0s 1 normal none running none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      background: "none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0)",
      backgroundBlendMode: "normal",
      baselineShift: 0,
      blockSize: "auto",
      borderBlock: "0px none rgb(0, 0, 0)",
      border: "0px none rgb(0, 0, 0)",
      borderRadius: 0,
      borderCollapse: "separate",
      borderInline: "0px none rgb(0, 0, 0)",
      inset: "auto",
      boxShadow: "none",
      boxSizing: "content-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(0, 0, 0)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(0, 0, 0)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columns: "auto auto",
      gap: "normal",
      columnRule: "0px none rgb(0, 0, 0)",
      columnSpan: "none",
      content: "normal",
      cursor: "default",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "block",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(102, 76, 109)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flex: "0 1 auto",
      flexFlow: "row nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      font: "700 28px Quicksand",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridArea: "auto / auto / auto / auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlock: "auto",
      insetInline: "auto",
      isolation: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      listStyle: "outside none disc",
      marginBlock: 0,
      margin: 0,
      marginInline: 0,
      marker: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offset: "none 0px auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outline: "rgb(0, 0, 0) none 0px",
      outlineOffset: 0,
      overflowAnchor: "auto",
      overflowWrap: "normal",
      overflow: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlock: 0,
      padding: 0,
      paddingInline: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0.1875px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlock: 0,
      scrollMarginInline: 0,
      scrollPaddingBlock: "auto",
      scrollPaddingInline: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "middle",
      textDecoration: "none solid rgb(0, 0, 0)",
      textDecorationSkipInk: "auto",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "auto",
      textTransform: "none",
      textUnderlinePosition: "auto",
      touchAction: "auto",
      transform: "matrix(1, 0, 0, 1, -155, 53)",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transition: "all 0s ease 0s",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "nowrap",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      borderSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLocale: "&quot",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMask: "none 0% 0% / auto repeat border-box border-box",
      WebkitMaskComposite: "source-over",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0.18)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasis: "none rgb(0, 0, 0)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextFillColor: "rgb(0, 0, 0)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStroke: "0px rgb(0, 0, 0)",
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }, "ausb\xFCgler"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "rgb(147, 73, 169)",
    fontFamily: "Quicksand",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(167, -61)",
    fontSize: "28px",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      placeContent: "normal",
      placeItems: "normal",
      placeSelf: "auto",
      alignmentBaseline: "auto",
      animation: "0s ease 0s 1 normal none running none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      background: "none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0)",
      backgroundBlendMode: "normal",
      baselineShift: 0,
      blockSize: "auto",
      borderBlock: "0px none rgb(0, 0, 0)",
      border: "0px none rgb(0, 0, 0)",
      borderRadius: 0,
      borderCollapse: "separate",
      borderInline: "0px none rgb(0, 0, 0)",
      inset: "auto",
      boxShadow: "none",
      boxSizing: "content-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(0, 0, 0)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(0, 0, 0)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columns: "auto auto",
      gap: "normal",
      columnRule: "0px none rgb(0, 0, 0)",
      columnSpan: "none",
      content: "normal",
      cursor: "default",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "block",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(147, 73, 169)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flex: "0 1 auto",
      flexFlow: "row nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      font: "700 28px Quicksand",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridArea: "auto / auto / auto / auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlock: "auto",
      insetInline: "auto",
      isolation: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      listStyle: "outside none disc",
      marginBlock: 0,
      margin: 0,
      marginInline: 0,
      marker: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offset: "none 0px auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outline: "rgb(0, 0, 0) none 0px",
      outlineOffset: 0,
      overflowAnchor: "auto",
      overflowWrap: "normal",
      overflow: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlock: 0,
      padding: 0,
      paddingInline: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0.1875px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlock: 0,
      scrollMarginInline: 0,
      scrollPaddingBlock: "auto",
      scrollPaddingInline: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "middle",
      textDecoration: "none solid rgb(0, 0, 0)",
      textDecorationSkipInk: "auto",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "auto",
      textTransform: "none",
      textUnderlinePosition: "auto",
      touchAction: "auto",
      transform: "matrix(1, 0, 0, 1, 167, -61)",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transition: "all 0s ease 0s",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "nowrap",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      borderSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLocale: "&quot",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMask: "none 0% 0% / auto repeat border-box border-box",
      WebkitMaskComposite: "source-over",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0.18)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasis: "none rgb(0, 0, 0)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextFillColor: "rgb(0, 0, 0)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStroke: "0px rgb(0, 0, 0)",
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }, "gl\xFCcklichmacher"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#9349a9",
    fontFamily: "Quicksand",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-28, -109)",
    fontSize: "28px",
    tabIndex: 0,
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      placeContent: "normal",
      placeItems: "normal",
      placeSelf: "auto",
      alignmentBaseline: "auto",
      animation: "0s ease 0s 1 normal none running none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      background: "none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0)",
      backgroundBlendMode: "normal",
      baselineShift: 0,
      blockSize: "auto",
      borderBlock: "0px none rgb(0, 0, 0)",
      border: "0px none rgb(0, 0, 0)",
      borderRadius: 0,
      borderCollapse: "separate",
      borderInline: "0px none rgb(0, 0, 0)",
      inset: "auto",
      boxShadow: "none",
      boxSizing: "content-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(0, 0, 0)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(0, 0, 0)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columns: "auto auto",
      gap: "normal",
      columnRule: "0px none rgb(0, 0, 0)",
      columnSpan: "none",
      content: "normal",
      cursor: "default",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "block",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(147, 73, 169)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flex: "0 1 auto",
      flexFlow: "row nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      font: "700 28px Quicksand",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridArea: "auto / auto / auto / auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlock: "auto",
      insetInline: "auto",
      isolation: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      listStyle: "outside none disc",
      marginBlock: 0,
      margin: 0,
      marginInline: 0,
      marker: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offset: "none 0px auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outline: "rgb(0, 0, 0) none 0px",
      outlineOffset: 0,
      overflowAnchor: "auto",
      overflowWrap: "normal",
      overflow: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlock: 0,
      padding: 0,
      paddingInline: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "-0.3128px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlock: 0,
      scrollMarginInline: 0,
      scrollPaddingBlock: "auto",
      scrollPaddingInline: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "middle",
      textDecoration: "none solid rgb(0, 0, 0)",
      textDecorationSkipInk: "auto",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "auto",
      textTransform: "none",
      textUnderlinePosition: "auto",
      touchAction: "auto",
      transform: "matrix(1, 0, 0, 1, -28, -109)",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transition: "all 0s ease 0s",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "nowrap",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      borderSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLocale: "&quot",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMask: "none 0% 0% / auto repeat border-box border-box",
      WebkitMaskComposite: "source-over",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0.18)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasis: "none rgb(0, 0, 0)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextFillColor: "rgb(0, 0, 0)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStroke: "0px rgb(0, 0, 0)",
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }, "tr\xE4nentrockner"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "rgb(102, 76, 109)",
    fontFamily: "Quicksand",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-336, -74)",
    fontSize: "28px",
    tabIndex: 0,
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      placeContent: "normal",
      placeItems: "normal",
      placeSelf: "auto",
      alignmentBaseline: "auto",
      animation: "0s ease 0s 1 normal none running none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      background: "none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0)",
      backgroundBlendMode: "normal",
      baselineShift: 0,
      blockSize: "auto",
      borderBlock: "0px none rgb(0, 0, 0)",
      border: "0px none rgb(0, 0, 0)",
      borderRadius: 0,
      borderCollapse: "separate",
      borderInline: "0px none rgb(0, 0, 0)",
      inset: "auto",
      boxShadow: "none",
      boxSizing: "content-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(0, 0, 0)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(0, 0, 0)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columns: "auto auto",
      gap: "normal",
      columnRule: "0px none rgb(0, 0, 0)",
      columnSpan: "none",
      content: "normal",
      cursor: "default",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "block",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(102, 76, 109)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flex: "0 1 auto",
      flexFlow: "row nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      font: "700 28px Quicksand",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridArea: "auto / auto / auto / auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlock: "auto",
      insetInline: "auto",
      isolation: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      listStyle: "outside none disc",
      marginBlock: 0,
      margin: 0,
      marginInline: 0,
      marker: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offset: "none 0px auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outline: "rgb(0, 0, 0) none 0px",
      outlineOffset: 0,
      overflowAnchor: "auto",
      overflowWrap: "normal",
      overflow: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlock: 0,
      padding: 0,
      paddingInline: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0.046875px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlock: 0,
      scrollMarginInline: 0,
      scrollPaddingBlock: "auto",
      scrollPaddingInline: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "middle",
      textDecoration: "none solid rgb(0, 0, 0)",
      textDecorationSkipInk: "auto",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "auto",
      textTransform: "none",
      textUnderlinePosition: "auto",
      touchAction: "auto",
      transform: "matrix(1, 0, 0, 1, -336, -74)",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transition: "all 0s ease 0s",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "nowrap",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      borderSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLocale: "&quot",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMask: "none 0% 0% / auto repeat border-box border-box",
      WebkitMaskComposite: "source-over",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0.18)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasis: "none rgb(0, 0, 0)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextFillColor: "rgb(0, 0, 0)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStroke: "0px rgb(0, 0, 0)",
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }, "abschnittsgef\xE4hrte"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "rgb(102, 76, 109)",
    fontFamily: "Quicksand",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-172, -44)",
    fontSize: "28px",
    tabIndex: 0,
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      placeContent: "normal",
      placeItems: "normal",
      placeSelf: "auto",
      alignmentBaseline: "auto",
      animation: "0s ease 0s 1 normal none running none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      background: "none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0)",
      backgroundBlendMode: "normal",
      baselineShift: 0,
      blockSize: "auto",
      borderBlock: "0px none rgb(0, 0, 0)",
      border: "0px none rgb(0, 0, 0)",
      borderRadius: 0,
      borderCollapse: "separate",
      borderInline: "0px none rgb(0, 0, 0)",
      inset: "auto",
      boxShadow: "none",
      boxSizing: "content-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(0, 0, 0)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(0, 0, 0)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columns: "auto auto",
      gap: "normal",
      columnRule: "0px none rgb(0, 0, 0)",
      columnSpan: "none",
      content: "normal",
      cursor: "default",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "block",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(102, 76, 109)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flex: "0 1 auto",
      flexFlow: "row nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      font: "700 28px Quicksand",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridArea: "auto / auto / auto / auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlock: "auto",
      insetInline: "auto",
      isolation: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      listStyle: "outside none disc",
      marginBlock: 0,
      margin: 0,
      marginInline: 0,
      marker: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offset: "none 0px auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outline: "rgb(0, 0, 0) none 0px",
      outlineOffset: 0,
      overflowAnchor: "auto",
      overflowWrap: "normal",
      overflow: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlock: 0,
      padding: 0,
      paddingInline: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "-0.3128px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlock: 0,
      scrollMarginInline: 0,
      scrollPaddingBlock: "auto",
      scrollPaddingInline: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "middle",
      textDecoration: "none solid rgb(0, 0, 0)",
      textDecorationSkipInk: "auto",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "auto",
      textTransform: "none",
      textUnderlinePosition: "auto",
      touchAction: "auto",
      transform: "matrix(1, 0, 0, 1, -172, -44)",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transition: "all 0s ease 0s",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "nowrap",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      borderSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLocale: "&quot",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMask: "none 0% 0% / auto repeat border-box border-box",
      WebkitMaskComposite: "source-over",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0.18)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasis: "none rgb(0, 0, 0)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextFillColor: "rgb(0, 0, 0)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStroke: "0px rgb(0, 0, 0)",
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }, "traumerf\xFCller"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "rgb(147, 40, 178)",
    fontFamily: "Quicksand",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(17, 54)",
    fontSize: "28px",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      placeContent: "normal",
      placeItems: "normal",
      placeSelf: "auto",
      alignmentBaseline: "auto",
      animation: "0s ease 0s 1 normal none running none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      background: "none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0)",
      backgroundBlendMode: "normal",
      baselineShift: 0,
      blockSize: "auto",
      borderBlock: "0px none rgb(0, 0, 0)",
      border: "0px none rgb(0, 0, 0)",
      borderRadius: 0,
      borderCollapse: "separate",
      borderInline: "0px none rgb(0, 0, 0)",
      inset: "auto",
      boxShadow: "none",
      boxSizing: "content-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(0, 0, 0)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(0, 0, 0)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columns: "auto auto",
      gap: "normal",
      columnRule: "0px none rgb(0, 0, 0)",
      columnSpan: "none",
      content: "normal",
      cursor: "default",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "block",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(147, 40, 178)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flex: "0 1 auto",
      flexFlow: "row nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      font: "700 28px Quicksand",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridArea: "auto / auto / auto / auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlock: "auto",
      insetInline: "auto",
      isolation: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      listStyle: "outside none disc",
      marginBlock: 0,
      margin: 0,
      marginInline: 0,
      marker: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offset: "none 0px auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outline: "rgb(0, 0, 0) none 0px",
      outlineOffset: 0,
      overflowAnchor: "auto",
      overflowWrap: "normal",
      overflow: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlock: 0,
      padding: 0,
      paddingInline: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0.1875px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlock: 0,
      scrollMarginInline: 0,
      scrollPaddingBlock: "auto",
      scrollPaddingInline: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "middle",
      textDecoration: "none solid rgb(0, 0, 0)",
      textDecorationSkipInk: "auto",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "auto",
      textTransform: "none",
      textUnderlinePosition: "auto",
      touchAction: "auto",
      transform: "matrix(1, 0, 0, 1, 17, 54)",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transition: "all 0s ease 0s",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "nowrap",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      borderSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLocale: "&quot",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMask: "none 0% 0% / auto repeat border-box border-box",
      WebkitMaskComposite: "source-over",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0.18)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasis: "none rgb(0, 0, 0)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextFillColor: "rgb(0, 0, 0)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStroke: "0px rgb(0, 0, 0)",
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }, "gedankenleser"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "rgb(102, 76, 109)",
    fontFamily: "Quicksand",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(166, 82)",
    fontSize: "28px",
    tabIndex: 0,
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      placeContent: "normal",
      placeItems: "normal",
      placeSelf: "auto",
      alignmentBaseline: "auto",
      animation: "0s ease 0s 1 normal none running none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      background: "none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0)",
      backgroundBlendMode: "normal",
      baselineShift: 0,
      blockSize: "auto",
      borderBlock: "0px none rgb(0, 0, 0)",
      border: "0px none rgb(0, 0, 0)",
      borderRadius: 0,
      borderCollapse: "separate",
      borderInline: "0px none rgb(0, 0, 0)",
      inset: "auto",
      boxShadow: "none",
      boxSizing: "content-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(0, 0, 0)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(0, 0, 0)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columns: "auto auto",
      gap: "normal",
      columnRule: "0px none rgb(0, 0, 0)",
      columnSpan: "none",
      content: "normal",
      cursor: "default",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "block",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(102, 76, 109)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flex: "0 1 auto",
      flexFlow: "row nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      font: "700 28px Quicksand",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridArea: "auto / auto / auto / auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlock: "auto",
      insetInline: "auto",
      isolation: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      listStyle: "outside none disc",
      marginBlock: 0,
      margin: 0,
      marginInline: 0,
      marker: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offset: "none 0px auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outline: "rgb(0, 0, 0) none 0px",
      outlineOffset: 0,
      overflowAnchor: "auto",
      overflowWrap: "normal",
      overflow: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlock: 0,
      padding: 0,
      paddingInline: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0.1875px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlock: 0,
      scrollMarginInline: 0,
      scrollPaddingBlock: "auto",
      scrollPaddingInline: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "middle",
      textDecoration: "none solid rgb(0, 0, 0)",
      textDecorationSkipInk: "auto",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "auto",
      textTransform: "none",
      textUnderlinePosition: "auto",
      touchAction: "auto",
      transform: "matrix(1, 0, 0, 1, 166, 82)",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transition: "all 0s ease 0s",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "nowrap",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      borderSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLocale: "&quot",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMask: "none 0% 0% / auto repeat border-box border-box",
      WebkitMaskComposite: "source-over",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0.18)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasis: "none rgb(0, 0, 0)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextFillColor: "rgb(0, 0, 0)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStroke: "0px rgb(0, 0, 0)",
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }, "wellengl\xE4tter"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "rgb(102, 76, 109)",
    fontFamily: "Quicksand",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-192, 124)",
    fontSize: "28px",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      placeContent: "normal",
      placeItems: "normal",
      placeSelf: "auto",
      alignmentBaseline: "auto",
      animation: "0s ease 0s 1 normal none running none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      background: "none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0)",
      backgroundBlendMode: "normal",
      baselineShift: 0,
      blockSize: "auto",
      borderBlock: "0px none rgb(0, 0, 0)",
      border: "0px none rgb(0, 0, 0)",
      borderRadius: 0,
      borderCollapse: "separate",
      borderInline: "0px none rgb(0, 0, 0)",
      inset: "auto",
      boxShadow: "none",
      boxSizing: "content-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(0, 0, 0)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(0, 0, 0)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columns: "auto auto",
      gap: "normal",
      columnRule: "0px none rgb(0, 0, 0)",
      columnSpan: "none",
      content: "normal",
      cursor: "default",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "block",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(102, 76, 109)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flex: "0 1 auto",
      flexFlow: "row nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      font: "700 28px Quicksand",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridArea: "auto / auto / auto / auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlock: "auto",
      insetInline: "auto",
      isolation: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      listStyle: "outside none disc",
      marginBlock: 0,
      margin: 0,
      marginInline: 0,
      marker: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offset: "none 0px auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outline: "rgb(0, 0, 0) none 0px",
      outlineOffset: 0,
      overflowAnchor: "auto",
      overflowWrap: "normal",
      overflow: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlock: 0,
      padding: 0,
      paddingInline: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "-0.15628px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlock: 0,
      scrollMarginInline: 0,
      scrollPaddingBlock: "auto",
      scrollPaddingInline: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "middle",
      textDecoration: "none solid rgb(0, 0, 0)",
      textDecorationSkipInk: "auto",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "auto",
      textTransform: "none",
      textUnderlinePosition: "auto",
      touchAction: "auto",
      transform: "matrix(1, 0, 0, 1, -192, 124)",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transition: "all 0s ease 0s",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "nowrap",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      borderSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLocale: "&quot",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMask: "none 0% 0% / auto repeat border-box border-box",
      WebkitMaskComposite: "source-over",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0.18)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasis: "none rgb(0, 0, 0)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextFillColor: "rgb(0, 0, 0)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStroke: "0px rgb(0, 0, 0)",
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }, "trendsetter"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "rgb(147, 73, 169)",
    fontFamily: "Quicksand",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(67, -144)",
    fontSize: "28px",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      placeContent: "normal",
      placeItems: "normal",
      placeSelf: "auto",
      alignmentBaseline: "auto",
      animation: "0s ease 0s 1 normal none running none",
      appearance: "none",
      backdropFilter: "none",
      backfaceVisibility: "visible",
      background: "none 0% 0% / auto repeat scroll padding-box border-box rgba(0, 0, 0, 0)",
      backgroundBlendMode: "normal",
      baselineShift: 0,
      blockSize: "auto",
      borderBlock: "0px none rgb(0, 0, 0)",
      border: "0px none rgb(0, 0, 0)",
      borderRadius: 0,
      borderCollapse: "separate",
      borderInline: "0px none rgb(0, 0, 0)",
      inset: "auto",
      boxShadow: "none",
      boxSizing: "content-box",
      breakAfter: "auto",
      breakBefore: "auto",
      breakInside: "auto",
      bufferedRendering: "auto",
      captionSide: "top",
      caretColor: "rgb(0, 0, 0)",
      clear: "none",
      clip: "auto",
      clipPath: "none",
      clipRule: "nonzero",
      color: "rgb(0, 0, 0)",
      colorInterpolation: "srgb",
      colorInterpolationFilters: "linearrgb",
      colorRendering: "auto",
      columns: "auto auto",
      gap: "normal",
      columnRule: "0px none rgb(0, 0, 0)",
      columnSpan: "none",
      content: "normal",
      cursor: "default",
      cx: 0,
      cy: 0,
      d: "none",
      direction: "ltr",
      display: "block",
      dominantBaseline: "auto",
      emptyCells: "show",
      fill: "rgb(147, 73, 169)",
      fillOpacity: 1,
      fillRule: "nonzero",
      filter: "none",
      flex: "0 1 auto",
      flexFlow: "row nowrap",
      float: "none",
      floodColor: "rgb(0, 0, 0)",
      floodOpacity: 1,
      font: "700 28px Quicksand",
      fontKerning: "auto",
      fontOpticalSizing: "auto",
      gridAutoColumns: "auto",
      gridAutoFlow: "row",
      gridAutoRows: "auto",
      gridArea: "auto / auto / auto / auto",
      gridTemplateAreas: "none",
      gridTemplateColumns: "none",
      gridTemplateRows: "none",
      height: "auto",
      hyphens: "manual",
      imageOrientation: "from-image",
      imageRendering: "auto",
      inlineSize: "auto",
      insetBlock: "auto",
      insetInline: "auto",
      isolation: "auto",
      letterSpacing: "normal",
      lightingColor: "rgb(255, 255, 255)",
      lineBreak: "auto",
      listStyle: "outside none disc",
      marginBlock: 0,
      margin: 0,
      marginInline: 0,
      marker: "none",
      maskType: "luminance",
      maxBlockSize: "none",
      maxHeight: "none",
      maxInlineSize: "none",
      maxWidth: "none",
      minBlockSize: 0,
      minHeight: 0,
      minInlineSize: 0,
      minWidth: 0,
      mixBlendMode: "normal",
      objectFit: "fill",
      objectPosition: "50% 50%",
      offset: "none 0px auto 0deg",
      opacity: 1,
      order: 0,
      orphans: 2,
      outline: "rgb(0, 0, 0) none 0px",
      outlineOffset: 0,
      overflowAnchor: "auto",
      overflowWrap: "normal",
      overflow: "visible",
      overscrollBehaviorBlock: "auto",
      overscrollBehaviorInline: "auto",
      paddingBlock: 0,
      padding: 0,
      paddingInline: 0,
      paintOrder: "normal",
      perspective: "none",
      perspectiveOrigin: "0.1875px 0px",
      pointerEvents: "auto",
      position: "static",
      r: 0,
      resize: "none",
      rubyPosition: "over",
      rx: "auto",
      ry: "auto",
      scrollBehavior: "auto",
      scrollMarginBlock: 0,
      scrollMarginInline: 0,
      scrollPaddingBlock: "auto",
      scrollPaddingInline: "auto",
      shapeImageThreshold: 0,
      shapeMargin: 0,
      shapeOutside: "none",
      shapeRendering: "auto",
      speak: "normal",
      stopColor: "rgb(0, 0, 0)",
      stopOpacity: 1,
      stroke: "none",
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeOpacity: 1,
      strokeWidth: 1,
      tabSize: 8,
      tableLayout: "auto",
      textAlign: "center",
      textAlignLast: "auto",
      textAnchor: "middle",
      textDecoration: "none solid rgb(0, 0, 0)",
      textDecorationSkipInk: "auto",
      textIndent: 0,
      textOverflow: "clip",
      textRendering: "auto",
      textShadow: "none",
      textSizeAdjust: "auto",
      textTransform: "none",
      textUnderlinePosition: "auto",
      touchAction: "auto",
      transform: "matrix(1, 0, 0, 1, 67, -144)",
      transformOrigin: "0px 0px",
      transformStyle: "flat",
      transition: "all 0s ease 0s",
      unicodeBidi: "normal",
      userSelect: "auto",
      vectorEffect: "none",
      verticalAlign: "baseline",
      visibility: "visible",
      whiteSpace: "nowrap",
      widows: 2,
      width: "auto",
      willChange: "auto",
      wordBreak: "normal",
      wordSpacing: 0,
      writingMode: "horizontal-tb",
      x: 0,
      y: 0,
      zIndex: "auto",
      zoom: 1,
      WebkitAppRegion: "none",
      borderSpacing: 0,
      WebkitBorderImage: "none",
      WebkitBoxAlign: "stretch",
      WebkitBoxDecorationBreak: "slice",
      WebkitBoxDirection: "normal",
      WebkitBoxFlex: 0,
      WebkitBoxOrdinalGroup: 1,
      WebkitBoxOrient: "horizontal",
      WebkitBoxPack: "start",
      WebkitFontSmoothing: "antialiased",
      WebkitHighlight: "none",
      WebkitHyphenateCharacter: "auto",
      WebkitLineBreak: "auto",
      WebkitLocale: "&quot",
      WebkitMaskBoxImageOutset: 0,
      WebkitMaskBoxImageRepeat: "stretch",
      WebkitMaskBoxImageSlice: "0 fill",
      WebkitMaskBoxImageSource: "none",
      WebkitMaskBoxImageWidth: "auto",
      WebkitMask: "none 0% 0% / auto repeat border-box border-box",
      WebkitMaskComposite: "source-over",
      WebkitPrintColorAdjust: "economy",
      WebkitRtlOrdering: "logical",
      WebkitTapHighlightColor: "rgba(0, 0, 0, 0.18)",
      WebkitTextCombine: "none",
      WebkitTextDecorationsInEffect: "none",
      WebkitTextEmphasis: "none rgb(0, 0, 0)",
      WebkitTextEmphasisPosition: "over right",
      WebkitTextFillColor: "rgb(0, 0, 0)",
      WebkitTextOrientation: "vertical-right",
      WebkitTextSecurity: "none",
      WebkitTextStroke: "0px rgb(0, 0, 0)",
      WebkitUserDrag: "auto",
      WebkitUserModify: "read-only",
      WebkitWritingMode: "horizontal-tb"
    }
  }, "partyretter")))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "                \n                @font-face { font-family: Quicksand; font-style: normal; font-weight: 400; font-display: swap; src: url(\"data:application/font-woff;base64,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\") format(\"woff\"); unicode-range: U+102-103, U+110-111, U+1EA0-1EF9, U+20AB; }\n\t\t\t\t@font-face { font-family: Quicksand; font-style: normal; font-weight: 400; font-display: swap; src: url(\"data:application/font-woff;base64,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\") format(\"woff\"); unicode-range: U+100-24F, U+259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF; }\n\t\t\t\t@font-face { font-family: Quicksand; font-style: normal; font-weight: 400; font-display: swap; src: url(\"data:application/font-woff;base64,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\") format(\"woff\"); unicode-range: U+0-FF, U+131, U+152-153, U+2BB-2BC, U+2C6, U+2DA, U+2DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD; }\n}")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.f6bb74595876e9bfc97af3e568e5cd4f.svg";
export { ForwardRef as ReactComponent };